var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMicOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.569 11.019c0 .6.4 1 1 1s1-.4 1-1v-5.7c0-1.1-.4-2.1-1.2-2.9-.7-.8-1.7-1.3-2.8-1.4s-2.2.2-3.1.8-1.6 1.6-1.8 2.6c-.1.5.2 1.1.8 1.2.5.1 1.1-.3 1.2-.8s.432-.882.9-1.3q.052-.046.107-.088c.944-.709 2.458-.547 3.293.288.4.4.6 1 .6 1.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.707 3.193a1 1 0 1 0-1.414 1.414L7.5 9.814V11.5a4.5 4.5 0 0 0 5.948 4.262l.8.8A5.998 5.998 0 0 1 6 11a1 1 0 1 0-2 0 8 8 0 0 0 7.017 7.94 1 1 0 0 0-.017.183V22a1 1 0 1 0 2 0v-2.877q0-.094-.017-.184a8 8 0 0 0 2.769-.873l4.54 4.541a1 1 0 0 0 1.415-1.414zm7.956 10.784-2.14-2.14a2.5 2.5 0 0 0 2.14 2.14",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 10a1 1 0 0 1 1 1 8 8 0 0 1-.772 3.429 1 1 0 0 1-1.807-.857A6 6 0 0 0 18 11a1 1 0 0 1 1-1"
})));
export default SvgIcMicOff;